import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { ATTRIBUTE_TYPE_NAMES } from "@store/constants";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { FC } from "react";

const ProductListAttributeFilters = getWidgetComponent("ProductList/ProductListAttributeFilters");

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

type Props = OwnProps;

const ProductListBranchStockedFilters: FC<Props> = ({ fields: { expandByDefault } }) => {
    const productListAttributeFiltersProps = {
        fields: {
            expandByDefault,
        },
        filter: (attributeTypes: AttributeTypeFacetModel[]) => {
            return attributeTypes?.filter(x => x.name === ATTRIBUTE_TYPE_NAMES.stocking);
        },
    };

    return <ProductListAttributeFilters {...productListAttributeFiltersProps} />;
};

const widgetModule: WidgetModule = {
    component: ProductListBranchStockedFilters,
    definition: {
        group: "Product List",
        displayName: "Branch Stocked Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
